<template>
  <div>
    <edit-page-header
      page="NOTICE"
      :date="form.created"
    >
      <el-button
        class="light-gray"
        @click="handleClickDelete"
      >
        삭제
      </el-button>
      <el-button
        class="black"
        @click="handleClickEdit"
      >
        수정
      </el-button>
    </edit-page-header>

    <div class="notice-form">
      <el-form
        :model="form"
        label-position="top"
        label-width="100px"
      >
        <el-form-item
          label="제목"
          prop="title"
        >
          <div class="notice-title">
			<span>
            {{ form.title }}
			</span>
          </div>
        </el-form-item>
        <el-form-item
          label="내용"
          prop="content"
          style="margin-bottom: 0;"
        >
          <div
            class="notice-content"
            v-html="form.contents"
          />
        </el-form-item>
        <el-form-item style="width: 330px; margin: 0;">
          <el-upload
            action=""
            multiple
            :limit="5"
            name="image"
            :file-list="initialFileList"
          />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import dateFns from "date-fns";
import { convertRelativeHref } from "@/utils/etc";
import EditPageHeader from "@/components/EditPageHeader";
import { fiflboxApi } from '@/utils/api';

export default {
	name: "NoticeViewForm",
	components: { EditPageHeader },
	props: ["data"],
	data() {
		return {
			initialFileList: [],
			form: {
				created: null,
				title: "",
				contents: "",
				images: [],
			},
			noticeId: null,
		};
	},
	async created() {
		this.noticeId = this.$route.params.noticeId;
		await this.syncData();
		this.$nextTick(() => {
      this.$nextTick(() => {
        convertRelativeHref(".notice-content a")
      })
    })
	},
	methods: {
		handleClickEdit() {
			this.$router.push(`/notices/${this.noticeId}/edit`).catch(()=>{});
		},
		handleClickDelete() {
			return this.$confirm("본 게시물을 삭제하시겠습니까?", "공지 삭제", {
				confirmButtonText: "확인",
				cancelButtonText: "취소",
				showClose: false,
				customClass: "fifl-message-box",
				confirmButtonClass: "gray",
				cancelButtonClass: "white",
				closeOnPressEscape: false,
			}).then(async () => {
				try {
          await fiflboxApi.v1.deleteCenterNotices(this.noticeId);

					this.$message({
						type: "success",
						message: "공지가 삭제됐습니다.",
					});

					this.$router.replace("/notices").catch(()=>{});
				} catch (err) {}
			});
		},
		async syncData() {
      let { data: notice } = await fiflboxApi.v1.getCenterNoticeById(this.noticeId)
			this.form = notice;
			this.date = dateFns.parse(notice.created);
			this.initialFileList = notice.images.map(image => {
				return {
					name: image.filename,
					url: image.image,
				};
			});
		}
	},
};
</script>

<style lang="scss">
.notice-form {
	background-color: #ffffff;
	padding: 30px 25px;
	border-radius: 10px;

	.notice-title {
		height: 50px;
		line-height: 50px;
		border-radius: 5px;
		border: solid 1px #d3d3d3;
		overflow: hidden;
		font-size: 15px;
		color: #4a4a4a;
		letter-spacing: -0.8px;
		padding: 0 20px;
		display: flex;
		span{
			overflow-y: hidden;
			overflow-x: auto;
			white-space: nowrap;
		}
	}

	.notice-content {
		height: 330px;
		overflow-y: auto;
		border-radius: 5px;
		border: solid 1px #d3d3d3;

		font-size: 15px;
		color: #4a4a4a;
		letter-spacing: -0.8px;

		padding: 20px;

		min-height: 300px;
	}
}
</style>
